import * as React from 'react';
import { isMobile } from 'react-device-detect';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';
import { checkClaimPartyModalShow, scrollToScrollClass, updateClaimPartyReducer, validateClaimParties, handleNextStep, handleStepBack, setFnolReducer, submitFollowUpQuestions } from '../../../actions/claimSubmitActions';
import { ThirdPartyConfigurations, THIRDPARTY_TYPE_PASSENGER, THIRDPARTY_TYPE_WITNESS } from '../../../constants/constants';
import { IThirdPartyConfig } from '../../../interfaces/ThirdParty/ThirdPartyInterface';
import ClaimsThirdPartyComponent from '../ThirdParty/ClaimsThirdPartyComponent';

class PassengersWitnesses extends React.Component<any, any>  {
    constructor(props) {
        super(props);
        this.state = {
            reRender: true,
            hasDriverType: undefined,
            passengerErrorList: [],
            witnessErrorList: [],
            submitted: false,
        };
        this.handleNext = this.handleNext.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
    }

    async handleAdd(partyType, value) {
        let flagReducer = "hasPassanger";
        if (partyType === THIRDPARTY_TYPE_WITNESS) {
            flagReducer = "hasWitnesses";
        }
        if (value && this.props.claimSubmit[flagReducer] != value) {
            await this.props.dispatchAction(updateClaimPartyReducer(partyType, 'add'));
            this.props.dispatchAction(setFnolReducer(flagReducer, value))
        } else if (!value) {
            await this.props.dispatchAction(checkClaimPartyModalShow(ThirdPartyConfigurations.find(x => x.thirdPartyConfigType == partyType) as IThirdPartyConfig, flagReducer));
        }
    }

    async handleNext() {
        var passengerErrorList = [];
        var witnessErrorList = [];
        if (this.props.claimSubmit.isStationary === "no") {
            if (this.props.claimSubmit.hasPassanger) {
                passengerErrorList = await this.props.dispatchAction(validateClaimParties(ThirdPartyConfigurations.find(x => x.thirdPartyConfigType == THIRDPARTY_TYPE_PASSENGER) as IThirdPartyConfig));
            }
        }
        if (this.props.claimSubmit.hasWitnesses) {
            witnessErrorList = await this.props.dispatchAction(validateClaimParties(ThirdPartyConfigurations.find(x => x.thirdPartyConfigType == THIRDPARTY_TYPE_WITNESS) as IThirdPartyConfig));
        }
        if (passengerErrorList.length !== 0 || witnessErrorList.length !== 0) {
            await this.setState({
                passengerErrorList: passengerErrorList,
                witnessErrorList: witnessErrorList,
                submitted: true,
            })
            scrollToScrollClass()
        }
        else if (this.props.claimSubmit.isStationary === "yes")
        {
            this.props.dispatchAction(submitFollowUpQuestions());
        }
        else if (this.props.claimSubmit.followUpType !== "pothole" && (this.props.claimSubmit.hasPassanger !== undefined && this.props.claimSubmit.hasWitnesses !== undefined)) {
            this.props.dispatchAction(handleNextStep());
        } else {
            this.props.dispatchAction(submitFollowUpQuestions());
        }
    }

    handleBack() {
        this.props.dispatchAction(handleStepBack())
    }

    public render() {
        return <>
            <div className="col ssp-container-fnol-claim-info ssp-container-fnol-step-header-padding road-surface">
                <div className="row noma">
                    <div className="col-12 nopa ssp-header-fnol-claim-info">
                        <div className="row noma">
                            <div className="fnol-step-header-icon-area">
                                <img src={'/my-policy/Images/Claims/Numbers/' + this.props.claimSubmit.selectedClaimStep.stepLabel + '-red.png'} alt={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} title={"Step " + this.props.claimSubmit.selectedClaimStep.stepLabel} />
                            </div>
                            <div className="col fnol-step-header-title-area">
                                <h3>{this.props.claimSubmit.selectedClaimStep.title.split('&')[0] + (isMobile ? " " : "") + this.props.claimSubmit.selectedClaimStep.title.split('&')[1]}</h3>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.claimSubmit.isStationary === "no" &&
                    <>
                        <div className="row noma glassclaims-parent-row ">
                            <div className="col-12 nopa">
                                <hr className="hr-minus21px" />
                            </div>
                            <div className="col nopa">
                            <p className="text-16 glassclaims-intro-p stationary-p"><b>Were there any passengers {this.props.claimSubmit.isCar ? "in the car" : "on the motorbike"} at the time<br className="fnol-newline" /></b>
                                    <img className={"ml-10px mb-0 completionTooltip"} id="PassengersToolTip" alt="" src="./images/icons-line-style-info-32-px.svg" data-tip data-for="PassengersToolTip" />
                                    <ReactTooltip arrowColor="transparent" className="passengerstooltip" id="PassengersToolTip" place="right" effect="solid">
                                    Passengers are the people {this.props.claimSubmit.isCar ? "inside your insured car" : "on your insured motorbike"} at the time of the incident.
                            </ReactTooltip></p>
                            </div>
                            <div className="nopa text-lg-right glassclaims-button-col">
                                <div className="row noma glassclaims-button-row">
                                    <div className="col nopa glassclaims-button-no">
                                        <button className={this.props.claimSubmit.hasPassanger !== undefined && this.props.claimSubmit.hasPassanger === false ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="passangerNo" onClick={() => this.handleAdd(THIRDPARTY_TYPE_PASSENGER, false)}>No</button>
                                    </div>
                                    <div className="glassclaims-mobile-gutter nopa"></div>
                                    <div className="col nopa glassclaims-button-yes">
                                        <button className={this.props.claimSubmit.hasPassanger !== undefined && this.props.claimSubmit.hasPassanger === true ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="passangerYes" onClick={() => this.handleAdd(THIRDPARTY_TYPE_PASSENGER, true)}>Yes</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {this.props.claimSubmit.hasPassanger == true &&
                            <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.passengers} ErrorList={this.state.passengerErrorList} Submitted={this.state.submitted} />
                        }
                    </>
                }
                <div className="row noma glassclaims-parent-row ">
                    <div className="col-12 nopa">
                        <hr className="hr-minus21px mt-30px" />
                    </div>
                    <div className="col nopa">
                        <p className="text-16 glassclaims-intro-p stationary-p"><b>Did anyone witness the incident<br className="fnol-newline" /></b>
                            <img className={"ml-10px mb-0 completionTooltip"} id="WitnessesToolTip" alt="" src="./images/icons-line-style-info-32-px.svg" data-tip data-for="WitnessesToolTip" />
                            <ReactTooltip arrowColor="transparent" className="witnessestooltip" id="WitnessesToolTip" place="right" effect="solid">
                                Witnesses are people who witnessed the incident. This excludes passengers inside/on your or a third party's vehicle.
                            </ReactTooltip></p>
                    </div>
                    <div className="nopa text-lg-right glassclaims-button-col">
                        <div className="row noma glassclaims-button-row">
                            <div className="col nopa glassclaims-button-no">
                                <button className={this.props.claimSubmit.hasWitnesses !== undefined && this.props.claimSubmit.hasWitnesses === false ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="witnessesNo" onClick={() => this.handleAdd(THIRDPARTY_TYPE_WITNESS, false)}>No</button>
                            </div>
                            <div className="glassclaims-mobile-gutter nopa"></div>
                            <div className="col nopa glassclaims-button-yes">
                                <button className={this.props.claimSubmit.hasWitnesses !== undefined && this.props.claimSubmit.hasWitnesses === true ? "btn btn-outline-dark nopa fnol-repairs-button active" : "btn btn-outline-dark nopa fnol-repairs-button"} id="witnessesYes" onClick={() => this.handleAdd(THIRDPARTY_TYPE_WITNESS, true)}>Yes</button>
                            </div>
                        </div>
                    </div>
                </div>
                {this.props.claimSubmit.hasWitnesses == true &&
                    <ClaimsThirdPartyComponent ThirdParties={this.props.claimSubmit.witnesses} ErrorList={this.state.witnessErrorList} Submitted={this.state.submitted} />
                }
                <div className="col-12 nopa">
                    <hr className="hr-minus21px" />
                </div>
            </div>
            <div className="col-12 nopa fnol-where-it-happened-buttonholder pb-20px">
                <button id="submit" className={(this.props.claimSubmit.isStationary === "no" && this.props.claimSubmit.followUpType !== "pothole") ? 'btn btn-solid-red fnol-buttonreverse-button-next' : 'btn btn-solid-green fnol-buttonreverse-button-next'} onClick={this.handleNext}>{(this.props.claimSubmit.isStationary === "no" && this.props.claimSubmit.followUpType !== "pothole") ? 'Next' : 'Done'}</button>
                <button id="back" className="btn btn-outline-red fnol-buttonreverse-button-back" onClick={this.handleBack}>Back</button>
            </div>
        </>
    }
}

const mapStateToProps = (state: any) => {
    return {
        props: state.loadingScreen,
        profile: state.profile,
        claimSubmit: state.claimSubmit,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PassengersWitnesses)